import { render } from "./ProviderItem.vue?vue&type=template&id=e5b7dcba"
import script from "./ProviderItem.vue?vue&type=script&lang=js"
export * from "./ProviderItem.vue?vue&type=script&lang=js"

import exportComponent from "/root/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__